module.exports = __webpack_public_path__ + "img/预警信号@2x.6439a828.png";